"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchIp = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const fetchIp = async (xhr) => {
    const API = xhr || new web_ui_framework_1.XHR();
    try {
        const url = `${window.MIDDLEWARE_BASE_HOST}/mb-api-localization/v1/my/ip`;
        const { data } = await API.GET(url);
        return data?.ip;
    }
    catch (e) {
        return '';
    }
};
exports.fetchIp = fetchIp;
//# sourceMappingURL=ip.utility.js.map